export default __webpack_public_path__ + "static/media/Delete.e093793c.svg";